import React from "react";
// import "./item.css";

function TodosError() {
  return <p>ERROR!!!</p>;
}
export { TodosError };



// WEBPACK FOOTER //
// ./src/todoserror/todoserror.js